import React from 'react';
import { useCompensation } from '../hooks/useCompensation';
import ProjectDetail from './ProjectDetail';
import './ProjectDetail.css';

const Compensation = ({ onBackToHome, language, setLanguage }) => {
  const {
    translations,
    getTaluks,
    getHoblis,
    getVillages,
    getSelectedTaluk,
    getSelectedHobli,
    getSelectedVillage,
    handleTalukChange,
    handleHobliChange,
    handleVillageChange,
    handleSubmit,
    formatCurrency,
    canSubmit,
    villageData,
    isSubmitted
  } = useCompensation(language, setLanguage);

  return (
    <div className="compensation-wrapper">
      <ProjectDetail
        language={language}
        selectedTaluk={getSelectedTaluk()}
        selectedHobli={getSelectedHobli()}
        selectedVillage={getSelectedVillage()}
        onTalukChange={handleTalukChange}
        onHobliChange={handleHobliChange}
        onVillageChange={handleVillageChange}
        onSubmit={handleSubmit}
        translations={translations}
        taluks={getTaluks()}
        hoblis={getHoblis()}
        villages={getVillages()}
        canSubmit={canSubmit}
        villageData={villageData}
        isSubmitted={isSubmitted}
        formatCurrency={formatCurrency}
      />
    </div>
  );
};

export default Compensation;

